import { PROGRAM_TYPES } from 'site-modules/shared/components/incentives/incentives-wizard/constants/program-types';
import { UTILITY_EV_CHARGING_OFFER_SUBTYPE_ID } from 'site-modules/shared/components/incentives/incentives-wizard/constants/subtype-ids';

export const isUtilityEvChargingOfferRebate = ({ programType, subtypeId }) =>
  programType === PROGRAM_TYPES.CHARGER_INSTALLATION && subtypeId === UTILITY_EV_CHARGING_OFFER_SUBTYPE_ID;
